// eslint-disable-next-line no-undef
class OmetriaForm extends window.BAO.CustomElement() {
  setupListeners () {
    if (this.els?.form) {
      this.listeners.add(
        this.els.form.element,
        'submit',
        this.handleFormSubmit.bind(this),
      )
    }

    if (this.els.optIn) {
      this.listeners.add(
        this.els.optIn.element,
        'change',
        this.setOptIn.bind(this),
      )
    }

    if (this.els.optSms) {
      this.listeners.add(
        this.els.optSms.element,
        'change',
        this.setSMSIn.bind(this),
      )
    }

    const phoneInput = this.els.phone

    if (phoneInput) {
      this.setupCountryCode = this.setupCountryCode.bind(this)
      this.listeners.add(window, 'load', this.setupCountryCode)

      this.handlePhoneInput = this.handlePhoneInput.bind(this)
      this.listeners.add(this.els.phone.element, 'input', this.handlePhoneInput)
      this.listeners.add(
        this.els.phone.element,
        'countrychange',
        this.handlePhoneInput,
      )
    }
  }

  async handleFormSubmit (e) {
    e.preventDefault()
    this.setLoading(true)

    const form = e.target

    if (this.emailIsValid()) {
      try {
        const response = await fetch('https://api.ometria.com/forms/signup/ajax', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          },
          body: this.formatFormData(form),
        })

        if (response.ok) {
          this.showSuccess()
        } else {
          // Try to get error message from response
          const errorData = await response.json().catch(() => ({}))
          this.handleError([['error', errorData.message || 'There was an error submitting the form. Please try again.']])
        }
      } catch (error) {
        console.error('Form submission error:', error)
        this.handleError([['error', 'There was an error submitting the form. Please try again.']])
      }
    } else {
      this.handleError([
        ['error', this.els.email.element.dataset.emailValidationError || 'Please enter a valid email address'],
      ])
    }

    this.setLoading(false)
  }

  emailIsValid () {
    const email = this.els.email.element.value
    const disallowedDomains = this.els.email.element.dataset.disallowedDomains

    // Email is empty
    if (!email) {
      return false
    }

    // Common basic format pattern
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      return false
    }

    // Domains passed from custom metafield via data attr
    if (disallowedDomains) {
      // Domain checker
      const [, domain] = email.split('@')

      if (!domain) {
        return false
      }

      const disallowed = disallowedDomains
        .split(',')
        .map(domain => domain.trim())

      if (disallowed.includes(domain)) {
        return false
      }
    }

    return true
  }

  setupCountryCode () {
    if (!this.els.phone) return

    this.iti = window.intlTelInput(this.els.phone.element, {
      utilsScript:
        'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
      separateDialCode: true,
      showFlags: this.els.phone.element.dataset.showFlags === 'true',
      initialCountry: 'auto',
      strictMode: true,
      async geoIpLookup (callback) {
        const response = await window.BAO.Utils.fetchJSON(
          '/browsing_context_suggestions.json',
          {
            method: 'GET',
          },
        )

        callback(response.detected_values.country.handle)
      },
    })
  }

  async handlePhoneInput () {
    if (this.els.smsInput) {
      if (this.els.phoneFormatted.element.value !== '') {
        this.els.smsInput.element.removeAttribute('hidden')
      }
    }

    if (this.iti && this.els.phone) {
      const formattedNumber = await this.iti.getNumber()
      this.els.phoneFormatted.element.value = formattedNumber || this.els.phone.element.value
    }
  }

  formatFormData (form) {
    const formElements = form.elements

    const urlEncodedDataPairs = Object.keys(formElements).map(key => {
      const { name, value } = formElements[key]
      return `${encodeURIComponent(name)}=${encodeURIComponent(value)}`
    })

    return urlEncodedDataPairs.join('&').replace(/%20/g, '+')
  }

  handleError (errors) {
    this.setLoading(false)
    this.setMessage(errors.map(error => `<h3>${error[1]}</h3>`))
  }

  showSuccess () {
    this.setMessage(`<h3>${this.dataset.success || 'Thank you for signing up!'}</h3>`)
    this.els.messages.element.classList.add('nws-Newsletter_Messages-success')
    this.els.fields.element.remove()
  }

  setMessage (messages) {
    this.els.messages.element.innerHTML = messages
  }

  setLoading (isLoading) {
    this.els.submit.element.disabled = isLoading
  }

  setSMSIn (e) {
    if (!this.els.smsHiddenField) return

    this.els.smsHiddenField.element.value = e.target.checked ? 'true' : 'false'
  }

  setOptIn (e) {
    if (!this.els.marketingHiddenField) return

    this.els.marketingHiddenField.element.value = e.target.checked
      ? 'SUBSCRIBED'
      : 'UNCHANGED'
  }
}

if (!customElements.get('ometria-form')) {
  customElements.define('ometria-form', OmetriaForm)
}
